var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipmentsV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3674 14.2571H3.92017M12.3674 14.2571H16.5551M12.3674 14.2571C12.3674 14.2571 12.3674 11.6281 12.3674 9.94356V5.63C12.3674 5.1977 11.8768 4.47742 11.8768 4.47742C11.8768 4.47742 11.1366 4 10.6924 4H3.92017",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5542 15.0723C16.5542 15.9725 15.7332 16.7023 14.7205 16.7023C13.7077 16.7023 12.8867 15.9725 12.8867 15.0723",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40579 15.0723C8.40579 15.9725 7.58479 16.7023 6.57203 16.7023C5.55928 16.7023 4.73828 15.9725 4.73828 15.0723",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81641 7.08203H4.26141",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.88086L4.26001 9.88086",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4022 14.2562H18.1341C18.3638 14.2562 18.584 14.1703 18.7464 14.0175C18.9088 13.8646 19.0001 13.6573 19.0001 13.4412V11.2812C18.9997 11.0963 18.9325 10.9169 18.8095 10.7727L17.9014 9.70424L15.8861 7.80644C15.8051 7.71099 15.7023 7.63389 15.5854 7.58085C15.4685 7.5278 15.3404 7.50017 15.2106 7.5C15.0809 7.49983 12.5 7.5 12.5 7.5",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentsV2);
export default __webpack_public_path__ + "static/media/shipmentsV2.4ad4b3d75cbd82ce8bb3873d360322ac.svg";
export { ForwardRef as ReactComponent };